<template>
    <div class="card">
        <div class="card-body">
            <div class="row m-2">
                <div class="col-6 p-l-0">
                    <h2 class="count-number">{{ booksCount.toString().replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ') }}</h2>
                    <span class="count">КІЛЬКІСТЬ КНИЖОК</span>
                </div>
                <div class="col-6 p-r-0 text-right">
                    <i class="mdi mdi-library-books index-icon"></i>
                </div>
            </div>
            <div class="row m-2">
                <div class="col-12 p-r-0 p-l-0">
                  <form action="library/books" method="get">

                  <div class="input-group">
<!--                      @input="isTyping = true" v-model="searchReaders"-->
                        <input type="text" name="search" class="form-control input-index" placeholder="Знайти книгу">
                        <div class="input-group-btn">
                            <button type="submit" class="btn btn-link button-index">
                                <img src="/theme/icons/search.svg" width="24px">
                            </button>
                        </div>
                    </div>
                  </form>

                </div>
            </div>
<!--            <div align="center" v-if="isLoading">-->
<!--                <span>Пошук...</span>-->
<!--            </div>-->
<!--            <div class="list-group">-->
<!--                <a class="list-group-item list-group-item-action" href="#" v-on:click.prevent="$root.searchReader(item.code)" v-for="(item,i) in readersResult">-->
<!--                    <table>-->
<!--                        <tr>-->
<!--                            <td>-->
<!--                                <img v-bind:src="'/uploads/' + item.photo" style="height: 150px;" alt="" class="rounded float-left">-->
<!--                            </td>-->
<!--                            <td style="padding-left: 15px;">-->
<!--                                {{ item.fullname }}-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                    </table>-->
<!--                </a>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "SearchBook",
        data(){
          return {
            booksCount:0
          }
        },
        mounted() {
          this.getCount();
        },
        methods:{
            getCount(){
              axios.get('/api/counts?library='+this.$root.$data.libraryId)
                  .then(res => {
                    this.booksCount = res.data.count;
                  });
            }
          }
      }
</script>

<style scoped>

</style>